define('views/pages/basket/basket-collection',['require','views/base/collection','views/pages/basket/basket','text!templates/pages/basket/basket-collection.ejs'],function(require) {
    'use strict';

    var CollectionView = require('views/base/collection'),
        BasketView = require('views/pages/basket/basket'),
        template = require('text!templates/pages/basket/basket-collection.ejs');

    var BasketCollectionView = CollectionView.extend({
        template: template,
        itemView: BasketView,
        loadingSelector: '.loading',
        fallbackSelector: '.empty'
    });

    return BasketCollectionView;
});

